// module.pressure (contract §4.8.1): PressureModule (modules.tsx): the
// barometer now and its 3 h tendency as the headline pair, the 24 h curve as
// the body; "No barometer reported." when the boat has none.

import { css, h, rangeChip } from "./kit.js";
import { F, S } from "./module-kit.js";

export function modulePressure() {
  return {
    lane: true,
    kind: true,
    html: [
      h("i", { class: "mo-flag", ...F("state") }),
      h("p", { class: "mo-msg", ...F("message") }),
      h(
        "div",
        { class: "pr-h" },
        h(
          "div",
          { class: "rd" },
          h(
            "span",
            { class: "rd-row rd-md" },
            h("span", { class: "rd-v", ...F("now") }),
            h("span", { class: "rd-u", ...F("now-unit") }),
          ),
        ),
        h(
          "div",
          { class: "rd mo-end" },
          h("span", { class: "rd-l pr-tl", ...F("trend-label") }),
          h(
            "span",
            { class: "rd-row rd-md" },
            h("span", { class: "mo-g", ...F("glyph") }),
            h("span", { class: "rd-v", ...F("rate") }),
            h("span", { class: "rd-u", ...F("rate-unit") }),
          ),
        ),
      ),
      h("div", { class: "mo-rc pr-rc" }, rangeChip()),
      h(
        "svg",
        {
          class: "mo-lane pr-lane",
          "data-tc-fit": "lane",
          "aria-hidden": "true",
        },
        h("path", {
          class: "ar",
          ...S("pressure", {
            "data-tc-shape": "area",
            "data-tc-inset": "3 1 3 1",
          }),
        }),
        h("path", {
          class: "ln",
          ...S("pressure", { "data-tc-inset": "3 1 3 1" }),
        }),
      ),
    ],
    css: css(`
      .mo-pressure { min-height: 0; padding-top: 6px; }
      .pr-h { display: flex; align-items: flex-start; justify-content: space-between; gap: 14px; flex: none; }
      .pr-h .rd-v[data-quality=missing] { display: inline; }
      .pr-lane { margin-top: 8px; min-height: 64px; }
      .mo-flag[data-state=none] ~ .pr-h, .mo-flag[data-state=none] ~ .pr-lane,
        .mo-flag[data-state=none] ~ .pr-rc { display: none; }
      /* The bento's half-row cell: a modest guaranteed lane. */
      html[data-slot=pressure] .pr-lane { min-height: 30px; }
      html[data-slot=pressure] .rd-l { font-size: 12px; }
    `),
  };
}
